import { useCallback, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { SeasonDateForm } from "@/components/CoachReadySeasonForm";

const shell = "max-w-md mx-auto px-4 py-16 sm:py-20";

export default function CoachReadySeason() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [invalid, setInvalid] = useState(!token);
  const onInvalid = useCallback(() => setInvalid(true), []);

  if (invalid) {
    return (
      <div className={shell} data-testid="cr-season-invalid">
        <h1 className="font-head font-semibold uppercase text-3xl text-[#1E1E1E]">This link isn&apos;t valid</h1>
        <p className="mt-3 text-[#3A3A3A]">Use the link in your latest Coach Ready email, or <Link to="/coach-ready/learn" className="underline">get your access link again</Link>.</p>
      </div>
    );
  }
  return (
    <div className={shell} data-testid="cr-season-page">
      <Seo title="When's your first practice?" brand="Coach Ready" description="Set your first-practice date for the Coach Ready weekly emails." path="/coach-ready/season" noindex />
      <span className="kicker text-[#DB9130]">Coach Ready</span>
      <h1 className="mt-2 font-head font-semibold uppercase text-4xl text-[#1E1E1E] leading-[1.02]">When&apos;s your first practice?</h1>
      <p className="mt-4 text-[#3A3A3A]">Every Monday of your season you&apos;ll get one short coaching email, timed to where you are. You can change this date anytime.</p>
      <SeasonDateForm token={token} onInvalid={onInvalid} />
      <p className="mt-8 text-sm text-[#6E6E6E]"><Link to={`/coach-ready/learn/${token}`} className="underline underline-offset-2" data-testid="cr-season-lessons-link">Back to your lessons</Link></p>
    </div>
  );
}
